import { createActionTypes } from 'utils/action/actionTypes';

export const GENERATE_QR_CODE = createActionTypes('GENERATE_QR_CODE');
